export const countryDialCodes = [
  {
    countryCode: 'NL',
    dialCode: '+31',
    flagEmoji: '🇳🇱',
  },
  {
    countryCode: 'BE',
    dialCode: '+32',
    flagEmoji: '🇧🇪',
  },
  {
    countryCode: 'AT',
    dialCode: '+43',
    flagEmoji: '🇦🇹',
  },
  {
    countryCode: 'BG',
    dialCode: '+359',
    flagEmoji: '🇧🇬',
  },
  {
    countryCode: 'CY',
    dialCode: '+357',
    flagEmoji: '🇨🇾',
  },
  {
    countryCode: 'CZ',
    dialCode: '+420',
    flagEmoji: '🇨🇿',
  },
  {
    countryCode: 'DE',
    dialCode: '+49',
    flagEmoji: '🇩🇪',
  },
  {
    countryCode: 'DK',
    dialCode: '+45',
    flagEmoji: '🇩🇰',
  },
  {
    countryCode: 'EE',
    dialCode: '+372',
    flagEmoji: '🇪🇪',
  },
  {
    countryCode: 'ES',
    dialCode: '+34',
    flagEmoji: '🇪🇸',
  },
  {
    countryCode: 'FI',
    dialCode: '+358',
    flagEmoji: '🇫🇮',
  },
  {
    countryCode: 'FR',
    dialCode: '+33',
    flagEmoji: '🇫🇷',
  },
  {
    countryCode: 'GR',
    dialCode: '+30',
    flagEmoji: '🇬🇷',
  },
  {
    countryCode: 'HR',
    dialCode: '+385',
    flagEmoji: '🇭🇷',
  },
  {
    countryCode: 'HU',
    dialCode: '+36',
    flagEmoji: '🇭🇺',
  },
  {
    countryCode: 'IE',
    dialCode: '+353',
    flagEmoji: '🇮🇪',
  },
  {
    countryCode: 'IT',
    dialCode: '+39',
    flagEmoji: '🇮🇹',
  },
  {
    countryCode: 'LT',
    dialCode: '+370',
    flagEmoji: '🇱🇹',
  },
  {
    countryCode: 'LU',
    dialCode: '+352',
    flagEmoji: '🇱🇺',
  },
  {
    countryCode: 'LV',
    dialCode: '+371',
    flagEmoji: '🇱🇻',
  },
  {
    countryCode: 'MT',
    dialCode: '+356',
    flagEmoji: '🇲🇹',
  },
  {
    countryCode: 'PL',
    dialCode: '+48',
    flagEmoji: '🇵🇱',
  },
  {
    countryCode: 'PT',
    dialCode: '+351',
    flagEmoji: '🇵🇹',
  },
  {
    countryCode: 'RO',
    dialCode: '+40',
    flagEmoji: '🇷🇴',
  },
  {
    countryCode: 'SE',
    dialCode: '+46',
    flagEmoji: '🇸🇪',
  },
  {
    countryCode: 'SI',
    dialCode: '+386',
    flagEmoji: '🇸🇮',
  },
  {
    countryCode: 'SK',
    dialCode: '+421',
    flagEmoji: '🇸🇰',
  },
];

//TODO: Fix this implementation to complete use the dialCode instead of countryCode
export const countryDialCodesDropDownOptions = ({ defaultCountryCode = 'NL' }: { defaultCountryCode?: string }) => {
  const defaultCountry = countryDialCodes
    .filter((country) => country.countryCode === defaultCountryCode)
    .map((country) => {
      return {
        value: country.dialCode, // Changed from country.countryCode to country.dialCode
        label: `${country.flagEmoji} ${country.dialCode}`,
      };
    });
  const contryDialCodesFiltered = countryDialCodes
    .filter((country) => country.countryCode !== defaultCountryCode)
    .map((country) => {
      return {
        value: country.dialCode, // Changed from country.countryCode to country.dialCode
        label: `${country.flagEmoji} ${country.dialCode}`,
      };
    });
  return [...defaultCountry, ...contryDialCodesFiltered];
};
